import DataTable from './DataTable/DataTable';
import { createTheme, defaultThemes } from './DataTable/themes';

export { defaultThemes, createTheme };

export default DataTable;
